module.exports = __webpack_public_path__ + "static/media/Street-sunset.d03b51bd.svg";